import { utils } from '@kurtosys/ksys-app-template';
import { AppStoreBase } from './AppStoreBase';
import { IAppComponents } from '../models/IAppComponents';
import { computed } from 'mobx';
import { StoreContext } from '../../../configuration/StoreContext';
import { Manifest } from '../../../configuration/Manifest';
import { IGridProps } from '@kurtosys/ksys-app-components/dist/components/base/Grid/models';
import { IApplicationEmbedInput } from '@kurtosys/ksys-app-components/dist/components/base/ApplicationEmbed/models';
import { IInputs } from '../../../models/app/IInputs';

/* [Component: appStoreComponentImport] */

export class AppStore extends AppStoreBase {
	constructor(element: HTMLElement, url: string, storeContext: StoreContext, manifest: Manifest) {
		super(element, url, storeContext, manifest);
	}

	@computed
	get hasData(): boolean {
		return !!this.gridProps;
	}

	@computed
	get components(): IAppComponents {
		return {
			/* [Component: appStoreComponent] */
		};
	}

	@computed
	get rawGridProps(): IGridProps {
		return (this.appComponentConfiguration && this.appComponentConfiguration.gridProps) || {};
	}

	@computed
	get gridProps(): IGridProps | undefined {
		const gridProps: IGridProps = {
			...(utils.object.deepMergeObjects({}, this.rawGridProps)),
		};
		if (!utils.typeChecks.isNullOrEmpty(gridProps.breakpoints)) {
			gridProps.breakpoints.forEach(breakpoint => {
				if (breakpoint.props) {
					this.orchestrateGridProps(breakpoint.props);
					breakpoint.props.queryStore = this.storeContext.queryStore;
					breakpoint.props.loadUiIds = true;
				}
			});
		}
		this.orchestrateGridProps(gridProps);
		gridProps.queryStore = this.storeContext.queryStore;
		gridProps.loadUiIds = true;
		return gridProps; //
	}

	orchestrateGridProps = (gridProps: IGridProps) => {
		const { grid } = gridProps;

		if (grid) {
			const inputs: Partial<IInputs> = this.appParamsHelper.inputs || {};
			const embedInputs: IApplicationEmbedInput[] = (Object.keys(inputs) as (keyof IInputs)[]).map((key) => {
				const value = inputs[key] as any;
				return {
					key,
					value,
				};
			});
			const { rows = [] } = grid;
			rows.forEach((row) => {
				if (row) {
					const { columns = [] } = row;
					columns.forEach((column) => {
						if (column) {
							const { components = [] } = column;
							components.forEach((component) => {
								if (component) {
									switch (component.key) {
										case 'base.applicationEmbed':
											component.props = this.orchestrateEmbed(component.props, 'ksys-app-other', embedInputs);
											break;
									}
								}
							});
						}
					});
				}
			});
		}
		return gridProps;
	}

}